import { render, staticRenderFns } from "./global-search.vue?vue&type=template&id=50d27998&scoped=true&lang=pug"
import script from "./global-search.vue?vue&type=script&lang=js"
export * from "./global-search.vue?vue&type=script&lang=js"
import style0 from "./global-search.vue?vue&type=style&index=0&id=50d27998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d27998",
  null
  
)

export default component.exports